//api.js - API configuration with automatic authentication
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

// Create axios instance
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:9000',
});

// Request interceptor to add auth token to every request
api.interceptors.request.use(
  async (config) => {
    try {
      // Get the current auth session
      const session = await fetchAuthSession();
      
      if (session?.tokens?.accessToken) {
        // Add the ACCESS token to the Authorization header (not ID token)
        config.headers.Authorization = `Bearer ${session.tokens.accessToken}`;
        console.log('🔐 Added auth token to request:', config.url);
      } else {
        console.log('⚠️ No auth token available for request:', config.url);
      }
    } catch (error) {
      console.log('❌ Error getting auth session:', error.message);
      // Don't fail the request if we can't get auth - let the server handle it
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      console.log('🚪 Authentication failed - redirecting to login');
      
      // Clear local storage and redirect to login
      localStorage.removeItem('user');
      
      // Don't redirect if we're already on login/signup pages
      const currentPath = window.location.pathname;
      if (!currentPath.includes('/login') && !currentPath.includes('/accept-invite')) {
        window.location.href = '/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;